import React from 'react';
import { Layout, Menu } from 'antd';
import {
  HomeOutlined,
  FileSearchOutlined,
  DiffOutlined,
  FolderOpenOutlined
} from '@ant-design/icons';
import { theme } from '../../styles/theme';

const { Sider } = Layout;

const Sidebar = ({ currentPage, onNavigate, collapsed, onCollapse }) => {
  const menuItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: 'Home'
    },
    {
      key: 'documents',
      icon: <FolderOpenOutlined />,
      label: 'Documents',
      type: 'group',
      children: [
        {
          key: 'analyze',
          icon: <FileSearchOutlined />,
          label: 'Analyze Document'
        },
        {
          key: 'compare',
          icon: <DiffOutlined />,
          label: 'Compare Documents'
        }
      ]
    }
  ];

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      style={{
        background: theme.colors.bgSecondary,
        boxShadow: theme.shadows.md,
        borderRight: `1px solid ${theme.colors.borderGold}`
      }}
      width={240}
      trigger={null}
    >
      <Menu
        mode="inline"
        selectedKeys={[currentPage]}
        onClick={({ key }) => onNavigate(key)}
        items={menuItems}
        style={{
          height: '100%',
          borderRight: 0,
          paddingTop: '16px',
          background: theme.colors.bgSecondary
        }}
      />
    </Sider>
  );
};

export default Sidebar;
